"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//Algunos componentes de mas alto orden
const react_mapstate_1 = require("react-mapstate");
const cookies_1 = require("./cookies");
const React = require("react");
/**Convierte un componente controlado en uno no controlado, almacenando los valores no controlados en los cookies si es que el consumidor establece el prop cookieKey */
function makeUncontrolledCookies(valueKey, onChangeKey) {
    const ret = react_mapstate_1.mapState((props, state, setState) => (Object.assign({ 
        //Ponemos el valor del state en el prop del value
        [valueKey]: state.value, 
        //Pasamos en el onChange una función que establece el state y los cookies:
        [onChangeKey]: (value) => {
            setState({ value });
            if (props.cookieKey)
                cookies_1.cookies.Set("uncontrolledCookies_" + props.cookieKey, value);
        } }, props)), (props) => ({ value: props.cookieKey && cookies_1.cookies.Get("uncontrolledCookies_" + props.cookieKey) }));
    return ret;
}
exports.makeUncontrolledCookies = makeUncontrolledCookies;
/**
 * Convierte un componente controlado en uno no controlado, para el cual si se le pasa un value != undefined, se comporta como controlado
 * @param valueKey Nombre de la propiedad del valor
 * @param onChangeKey Nombre de la propiedad de la función de cambio en la forma (value) => void
 */
function makeUncontrolled(valueKey, onChangeKey, initialValue) {
    return react_mapstate_1.mapState((props, state, setState) => Object.assign({
        [valueKey]: state.value,
        [onChangeKey]: (value) => setState({ value })
    }, props), () => ({ value: initialValue }));
}
exports.makeUncontrolled = makeUncontrolled;
/**Vuelve un componente controlado uno no controlado, donde en el estado inicial no se le pasara ningun valor al props de value */
function mapStateUncontrolled(component) {
    return react_mapstate_1.mapState((props, state, setState) => (Object.assign({ onChange: (value) => setState({ value: value }) }, (state.value ? { value: state.value } : {}))), () => ({ value: undefined }))(component);
}
exports.mapStateUncontrolled = mapStateUncontrolled;
/**Mapea las props de un componente con una función, la función es obtenida de nuevo cada vez que se instancia el componente. Esto nos permite manejar fácilemente la memoización ya que
 * tenemos una función map diferente para cada componente
 */
function mapPropsThunk(Component, mapThunk, debugLabel = "MapPropsThunk") {
    const ret = class DefaultPropsComponent extends React.Component {
        constructor(props) {
            super(props);
            this.map = mapThunk();
        }
        render() {
            const props = this.map(this.props);
            return React.createElement(Component, Object.assign({}, props));
        }
    };
    const innerComp = Component;
    const innerName = innerComp.displayName || innerComp.name || "Component";
    ret.displayName = `${debugLabel}(${innerName})`;
    return ret;
}
exports.mapPropsThunk = mapPropsThunk;
/**Mapea los props de componente con una función */
function mapProps(Component, map) {
    return mapPropsThunk(Component, () => map, "MapProps");
}
exports.mapProps = mapProps;
/**Establece por default ciertas props de un componente */
function defaultProps(Component, defaults) {
    return mapPropsThunk(Component, () => x => (Object.assign({}, defaults, x)), "DefaultProps");
}
exports.defaultProps = defaultProps;
/**Establece por default ciertas props de un componente, los defaults se obtienen a travez de un thunk que se llama cada vez que se instancia un nuevo componente. Esto permite manejar fácilmente la memoización
 * ya que tenemos un objeto defaults diferente para cada instance de componente
 */
function defaultPropsThunk(Component, defaultsThunk) {
    return mapPropsThunk(Component, () => {
        const defaults = defaultsThunk();
        return x => (Object.assign({}, defaults, x));
    }, "DefaultPropsThunk");
}
exports.defaultPropsThunk = defaultPropsThunk;
/**Devuelve un componente que controla internamente su valor y sólamente lo reporta cuando el usuario sale del foco del control o despues de 300ms de haber cambiado el valor */
function debounce(Component, delay = 500) {
    const ret = class ThrottleOnChangeComp extends React.PureComponent {
        constructor(props) {
            super(props);
            this.lastValue = {};
            this.raiseOnChange = (value) => {
                if (this.props.onChange && this.lastValue !== value) {
                    this.lastValue = value;
                    this.props.onChange(value);
                }
            };
            this.propsCount = 1;
            this.changeCount = 1;
            this.handleOnChange = async (value) => {
                this.changeCount++;
                const currentChangeCount = this.changeCount;
                this.setState({ valueVersion: this.propsCount + 1, value: value });
                setTimeout(() => {
                    if (currentChangeCount == this.changeCount) {
                        this.raiseOnChange(value);
                    }
                }, delay);
            };
            this.handleOnBlur = async () => {
                const currentValue = this.getCurrentValue();
                this.propsCount++;
                this.changeCount++;
                this.raiseOnChange(currentValue);
                if (this.props.onBlur) {
                    this.props.onBlur();
                }
            };
            this.getCurrentValue = () => this.state.valueVersion > this.propsCount ? this.state.value : this.props.value;
            this.state = { valueVersion: 0 };
        }
        componentWillReceiveProps(nextProps) {
            const oldProps = this.props;
            if (nextProps.value !== oldProps.value) {
                this.propsCount++;
            }
        }
        render() {
            const value = this.getCurrentValue();
            return React.createElement(Component, Object.assign({}, this.props, { value: value, onChange: this.handleOnChange, onBlur: this.handleOnBlur }));
        }
    };
    const innerComp = Component;
    const innerName = innerComp.displayName || innerComp.name || "Component";
    ret.displayName = `Debounce(${innerName})`;
    return ret;
}
exports.debounce = debounce;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/HOC.js
// module id = 165
// module chunks = 0